import { GetterTree } from "vuex";
import { RootState } from "../types";
import { CandidatesInt } from "./types";
export const getters: GetterTree<CandidatesInt, RootState> = {};
